import { createContext } from "solid-js";
export const defaultStyledEngineContextValue = {
    cleanupStyles: true,
};
const StyledEngineContext = createContext(defaultStyledEngineContextValue);
export default StyledEngineContext;
